/*
 * @Name: 跨组件通信 emitter
 * @Description: 跨组件通信 emitter
 * @Author: xueshuai
 * @Date: 2021-03-01 09:40:59
 * @Editors: xueshuai
 */
/**
 * @description: 向下broadcast事件
 * @param {String} componentName 组件名称
 * @param {String} eventName 事件名称
 * @param {*} params 事件参数
 * @return {*}
 */
function broadcast(componentName, eventName, params) {
  this.$children.forEach(child => {
    var name = child.$options.name;

    if (name === componentName) {
      child.$emit.apply(child, [eventName].concat(params));
    } else {
      broadcast.apply(child, [componentName, eventName].concat([params]));
    }
  });
}
export default {
  methods: {
    /**
     * @description: 向上dispatch事件
     * @param {String} componentName 组件名称
     * @param {String} eventName 事件名称
     * @param {*} params 事件参数
     * @return {*}
     */
    dispatch(componentName, eventName, params) {
      var parent = this.$parent || this.$root;
      var name = parent.$options.name;

      while (parent && (!name || name !== componentName)) {
        parent = parent.$parent;

        if (parent) {
          name = parent.$options.name;
        }
      }
      if (parent) {
        parent.$emit.apply(parent, [eventName].concat(params));
      }
    },
    broadcast(componentName, eventName, params) {
      broadcast.call(this, componentName, eventName, params);
    }
  }
};
